/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Strossle/theme';

export const StrossleTheme = theme;
